import { IconButton, styled, SxProps, Theme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { MouseEventHandler } from 'react';

interface CloseButtonProps {
    padding?: number;
    marginBottom?: number;
    onClick?: MouseEventHandler<any> | undefined;
    sx?: SxProps<Theme>;
    color?: 'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
    iconSize?: number | string;
}

const CloseButton = ({ padding = 1, marginBottom = 0, iconSize = 20, onClick, color, sx }: CloseButtonProps) => {
    return (
        <IconButton sx={{ ...sx, padding, marginBottom }} onClick={onClick} color={color}>
            <CloseIcon sx={{ fontSize: iconSize }} />
        </IconButton>
    );
};

export default CloseButton;
